import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';
import { AuthProvider } from '../../providers/auth/auth';
import _ from 'lodash';
import { BehaviorSubject, Subject } from 'rxjs';
import { PatientProvider } from '../../providers/patient/patient';
import { UtilityProvider } from '../../providers/utility/utility';

@Component({
  selector: 'patient-adherence-call',
  templateUrl: 'patient-adherence-call.html'
})
export class PatientAdherenceCallComponent implements OnInit {
  private ngUnsubscribe: Subject<any> = new Subject();
  program_id: string;
  program_name: string;
  patient: any;
  exportjson: any;
  private _program_id = new BehaviorSubject<any>([]);
  private _program_name = new BehaviorSubject<any>([]);
  private _patient = new BehaviorSubject<any>([]);

  @Input()
  set programId(value) { this._program_id.next(value); }
  get programId() { return this._program_id.getValue(); }

  @Input()
  set programName(value) { this._program_name.next(value); }
  get programName() { return this._program_name.getValue(); }

  @Input()
  set patientData(value) { this._patient.next(value); }
  get patientData() { return this._patient.getValue(); }

  displayedColumns = ['callnumber', 'outcome', 'date', 'bloodpressure', 'dose', 'notes'];
  dataSource: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor( 
    private readonly auth: AuthProvider,
    private dbPatient: PatientProvider,
    public utility: UtilityProvider
    ) {
      this.auth.getCurrentUser().then(() => {
        this.dbPatient
        .listAdherenceCalls(this.program_id, this.patient.id)
        .snapshotChanges()
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            data.id = a.payload.doc.id;
            return data;
          });
        })
        .takeUntil(this.ngUnsubscribe)
        .subscribe(calls => {
          this.exportjson = calls;
          this.dataSource = new MatTableDataSource(calls);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })
      });
  }

  ngOnInit()  {
    this._program_id
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
        this.program_id = x
    });

    this._program_name
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
        this.program_name = x
    });

    this._patient
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
        this.patient = x
    });
  }

  ngOnDestroy() {
    console.log('Leave adherence calls and destroy subscriptions');
    this._patient.unsubscribe();
    this._program_id.unsubscribe();
    this._program_name.unsubscribe();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  export() {
    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(this.exportjson);

    XLSX.utils.book_append_sheet(workBook, workSheet, 'Adherence Calls'); // add the worksheet to the book
    XLSX.writeFile(workBook, this.patient.program_patient_id + '-adherencecalls.xlsx'); // initiate a file download in browser
  }
}



// WEBPACK FOOTER //
// ./src/components/patient-adherence-call/patient-adherence-call.ts